// src/pages/Login.jsx
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient'; // Ensure correct import
import { useAuth } from '../providers/AuthProvider';
import { redirectByRole } from '../App';
import { normalizeKoreanPhone, phoneToEmail } from '../utils/phone';

export default function Login() {
  const nav = useNavigate();
  const { user } = useAuth(); // Use centralized auth state
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Force hard reload helper for HashRouter
  const hardNav = (path) => {
    window.location.hash = path
    window.location.reload()
  }

  // Effect: Redirect if already logged in (based on AuthProvider state)
  useEffect(() => {
    if (user) {
      redirectByRole(hardNav);
    }
  }, [user]);

  async function onSubmit(e) {
    e.preventDefault();
    setError('');
    if (!phone || !password) {
      setError('핸드폰 번호와 비밀번호를 입력해주세요.');
      return;
    }
    setLoading(true);
    try {
      // 로그인(signin) 로직
      // 사용자가 입력한 값
      console.log('[LOGIN] raw phone input:', phone);

      const normalizedPhone = normalizeKoreanPhone(phone);
      const email = phoneToEmail(phone);

      // 🔴 여기 로그가 핵심
      console.log('[LOGIN] normalizedPhone:', normalizedPhone);
      console.log('[LOGIN] email used for login:', email);

      const { error: err } = await supabase.auth.signInWithPassword({ email, password });
      if (err) throw err;

      // Successful login will trigger onAuthStateChange in AuthProvider
      // We manually trigger redirect here or let the effect handle it.
      // For robustness, we call redirect logic explicitly after success.
      await redirectByRole(hardNav);
    } catch (e) {
      // 오류 메시지가 객체 형태로 올 수 있으므로 문자열로 처리
      setError(e.message || '로그인 실패');
      setLoading(false); // 실패 시에만 로딩 끄기
    } finally {
      // 성공 시에는 페이지가 리로드되므로 setLoading(false) 불필요할 수 있으나 안전장치로 유지
      // if (!window.location.hash) setLoading(false); 
    }
  }

  // 회원가입 페이지로 이동하는 핸들러
  const handleSignupNavigation = () => {
    nav('/signup'); // 👈 /signup 페이지로 이동
  };

  return (
    <div className="max-w-md mx-auto">
      <h1 className="text-xl font-bold mb-4">로그인</h1>
      <div className="rounded-2xl border bg-white p-4">
        <form onSubmit={onSubmit} className="grid gap-3">
          <input
            className="input"
            type="tel"
            placeholder="핸드폰 번호"
            value={phone}
            onChange={e => setPhone(e.target.value)}
            autoComplete="tel"
          />
          <input
            className="input"
            type="password"
            placeholder="비밀번호"
            value={password}
            onChange={e => setPassword(e.target.value)}
            autoComplete="current-password"
          />
          {error && <div className="text-sm text-rose-600">{error}</div>}
          <button
            className="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-60"
            disabled={loading}
            type="submit"
          >
            {loading ? '처리 중…' : '로그인'}
          </button>
        </form>

        <div className="mt-3 text-sm text-gray-600 flex items-center justify-between">
          <div>
            {/* 회원가입 버튼을 눌렀을 때 /signup으로 이동하도록 수정 */}
            계정이 없으신가요?{' '}
            <button
              className="underline"
              onClick={handleSignupNavigation} // 👈 이 함수를 호출하여 페이지 이동
            >
              회원가입
            </button>
          </div>
          <button
            className="underline"
            onClick={() => { window.location.href = '/reset-request' }}
          >
            비밀번호 재설정
          </button>
        </div>
      </div>
    </div>
  );
}